import axios from 'axios';
import toast from 'react-hot-toast';
import { authenticationServices } from './authenticateServices';
let tokenName = "token";

const serverError = { Succeed: false, Message: "Can't Reach the Server, please try again later", ClassName: "Error" };
const requestError = { Succeed: false, Message: "Oops, something went wrong, please try again later", ClassName: "Error" };
const instance = axios.create({
    baseURL: process.env.REACT_APP_API,
});
const generateAPI = (action, method) => {
    return `/${action}/${method}`;
}
const requestType = { Post: "post", Put: "put", Get: "get", Delete: "delete" };
const callAPI = async (rType, action, method, data, needAuthenticated = true, includeFile = false, retry = false) => {
    // let token = localStorage.getItem(tokenName) ?? undefined;
    const token = authenticationServices.getToken();
    if (needAuthenticated && !token) return Promise.reject({ isTimeout: false, error: 401 });
    try {
        const authHeader = needAuthenticated ? { "Authorization": "Bearer " + token } : {};
        const response = await instance({
            method: rType,
            url: generateAPI(action, method),
            headers: { "content-type": includeFile ? "multipart/form-data" : "application/json", "Timezone-Offset": new Date().getTimezoneOffset(), ...authHeader },
            ...data
        });

        // return response.status === 200 ? response.data : requestError;
        return response.data;

    } catch (error) {
        if (error.response !== undefined) {
            if (error.response.status === 401) {
                if (retry) {
                    await authenticationServices.logout();
                }
                const refreshTokenResult = await authenticationServices.loginWithToken();
                if (refreshTokenResult) {
                    return callAPI(rType, action, method, data, needAuthenticated, includeFile, true);
                }
                else { await authenticationServices.logout(); }
            }
            return error.response.data;
        }
        else {

            toast.error('Network Error, Please try again Later');
            return serverError;
        }
    }
}

export const insertAPI = async (action, params) => {
    return callAPI(requestType.Post, action, "Insert", { data: params });
}
export const updateInfoAPI = async (action, params) => {
    return callAPI(requestType.Put, action, "UpdateInfo", { data: params });
}
export const updateAPI = async (action, params) => {
    return callAPI(requestType.Put, action, "Update", { data: params });
}
export const deleteAPI = async (action, params) => {
    return callAPI(requestType.Delete, action, "Delete", { data: params });
}
export const listAPI = async (action, params) => {
    return callAPI(requestType.Get, action, "Filter", { params: params });
}
export const getAPI = async (action, params) => {
    return callAPI(requestType.Get, action, "Get", { params: params });
}
export const ddlFilterAPI = async (action, params = null) => {
    let data = params !== null ? { params: params } : null;
    return callAPI(requestType.Get, action, "FilterDDL", data);
}
export const baseRequest = async (rType, action, method, params = null, needAuthenticated = true, includeFile = false) => {
    let data = {};
    if (params != null) {
        if (rType === requestType.Get)
            data = { params: params };
        else
            data = { data: params };

    }
    return callAPI(rType, action, method, data, needAuthenticated, includeFile);

}
export const getData = async (dataType) => {
    return await baseRequest("get", "Data", "Get", { Type: dataType, MemberID: authenticationServices.memberID });
}
